package com.milta.core.localization.translations.nl

import com.milta.core.localization.PackageLabelScanStrings

internal val PackageLabelScan = PackageLabelScanStrings(
    scanTitle = "Een etiket scannen",
    analysingTitle = "Etiket wordt gelezen…",
    analysingSubtitle = "We zoeken naar de naam, het adres en het telefoonnummer van de ontvanger. Dit duurt maar een paar seconden.",
    reviewTitle = "Levering bevestigen",
    deliveryDetectedLabel = "Levering gedetecteerd",
    allReadableLabel = "Alles leesbaar",
    fieldToCompleteSingularSuffix = "veld aan te vullen",
    fieldToCompletePluralSuffix = "velden aan te vullen",
    recipientNotDetectedValue = "Niet gedetecteerd",
    addressNotDetectedValue = "Niet gedetecteerd",
    phoneNotDetectedValue = "Niet gedetecteerd",
    fieldRequiredWarning = "Verplicht veld om de levering toe te voegen",
    recipientCorrectionPlaceholder = "Ontvanger invoeren…",
    addressCorrectionPlaceholder = "Adres invoeren…",
    unreadableTitle = "Etiket onleesbaar.",
    unreadableMessage = "Maak een nieuwe foto, gekaderd op het etiket, goed belicht en zonder reflectie.",
    maxAttemptsMessage = "Vul deze levering handmatig aan, of start de scan opnieuw met een nieuwe foto.",
)
